import React, { useEffect, useState } from 'react';
import { Form, Button, InputGroup } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';

function BuscarTransferenciasPorFecha({
  onTransferenciasFiltradas,
  limpiar,
}) {
  const [fechaDesde, setFechaDesde] = useState('');
  const [fechaHasta, setFechaHasta] = useState('');

  useEffect(() => {
    if (limpiar) {
      setFechaDesde('');
      setFechaHasta('');
    }
  }, [limpiar]);

  const convertirFecha = (fecha, hora) => {
    if (!fecha) return null;

    const [year, month, day] = fecha.split('-');

    return `${year}-${month}-${day}`;
  };

  const handleBuscar = (e) => {
    e.preventDefault();

    const desde = convertirFecha(
      fechaDesde,
      '00:00:00'
    );

    const hasta = convertirFecha(
      fechaHasta,
      '23:59:59'
    );

    onTransferenciasFiltradas(desde, hasta);
  };

  return (
    <Form
      onSubmit={handleBuscar}
      className="d-flex align-items-center"
    >
      <InputGroup className="input-group-sm me-2">

        <Form.Control
          type="date"
          value={fechaDesde}
          onChange={(e) => setFechaDesde(e.target.value)}
          className="form-control-sm"
        />

        <Form.Control
          type="date"
          value={fechaHasta}
          onChange={(e) => setFechaHasta(e.target.value)}
          className="form-control-sm"
        />

        <Button
          type="submit"
          className="btn btn-primary custom-button-lupa d-flex align-items-center"
        >
          <FaSearch className="me-1" />
        </Button>

      </InputGroup>
    </Form>
  );
}

export default BuscarTransferenciasPorFecha;